/**
 * Shared card chrome for EVERY canvas element — slide, doc, note, image — so their selection outline and rest
 * border are pixel-identical and can never drift apart (Beka: the selection outline must read the same on all
 * elements). Applied as box-shadow rings (no layout border, so nothing reflows):
 *
 *   • SELECTION_RING — the product's double ring: a 1px #fafafa hairline + a 3px primary outline, both
 *     counter-scaled by --sel-scale so the ring keeps a constant SCREEN width at any zoom.
 *   • REST_BORDER — a flat 1px default-color border when unselected.
 *
 * Use `cardChrome(selected)` for the box-shadow and `CARD_CHROME_TRANSITION` for the transition so the
 * outline animates in identically everywhere.
 */
export const SELECTION_RING =
  '0 0 0 calc(1px * var(--sel-scale, 1)) #fafafa, 0 0 0 calc(3px * var(--sel-scale, 1)) var(--color-state-primary, #2563eb)'

export const REST_BORDER = '0 0 0 1px var(--color-border-default)'

export const CARD_CHROME_TRANSITION = 'box-shadow 160ms ease'

/** The box-shadow for a canvas card: the shared selection ring when selected, the flat border otherwise. */
export const cardChrome = (selected: boolean): string => (selected ? SELECTION_RING : REST_BORDER)
